import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {UserRolesCellViewerComponent} from '@features/security/components/user-roles-cell-viewer/user-roles-cell-viewer.component';
import {ManageUserRolesComponent} from '@features/security/components/manage-user-roles/manage-user-roles.component';
import {ManageRoleUsersComponent} from '@features/security/components/manage-role-users/manage-role-users.component';
import {RolesAndUsersComponent} from '@features/security/components/roles-and-users/roles-and-users.component';
import {UsersAndRolesWithAccessComponent} from '@features/security/components/users-and-roles-with-access/users-and-roles-with-access.component';

export class SecurityDynamicComponentHelper {
  public static components: any;

  public static init() {

    if (SecurityDynamicComponentHelper.components) {
      return;
    }

    const components = {};
    components['UserRolesCellViewerComponent'] = UserRolesCellViewerComponent;
    components['ManageUserRolesComponent'] = ManageUserRolesComponent;
    components['ManageRoleUsersComponent'] = ManageRoleUsersComponent;
    components['RolesAndUsersComponent'] = RolesAndUsersComponent;
    components['UsersAndRolesWithAccessComponent'] = UsersAndRolesWithAccessComponent;

    SecurityDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    SecurityDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }

  public static getComponentArray(): any[] {
    SecurityDynamicComponentHelper.init();

    const componentArray = [];
    Object.keys(SecurityDynamicComponentHelper.components).forEach(key => {
      componentArray.push(SecurityDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
